import { version } from '../version.js';

const [ MAJOR_VERSION ] = version.split('.');
const PREMIUM_DOCUMENT_MODAL_ID = 'pr-document-visualizations-premium-content-modal';

export const PREMIUM_DOCUMENT_EVENT_NAME = `pr-document-visualizations-premium-content-v${MAJOR_VERSION}`;

export function setupPremiumDocumentHandler() {
    if (!document.getElementById(PREMIUM_DOCUMENT_MODAL_ID)) {
        const premiumContentModal = document.createElement('flux-premium-content-modal');
        premiumContentModal.id = PREMIUM_DOCUMENT_MODAL_ID;
        document.body.appendChild(premiumContentModal);

        document.addEventListener(PREMIUM_DOCUMENT_EVENT_NAME, (event) => {
            const { document } = event.detail;
            premiumContentModal.open(document);
        });
    }
}
